<template>

    <div class="brt-map-searchModule" ref="mapSearchModule">

        <div class="input-section" @click.stop="moduleState == 0 ? back() : ''" state = "moduleState">

            <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[0])">
                <i class="iconfont icon-search"></i>
                <!--<img @click.stop="setClick" src="../../../../../../public/images/setting.png" alt="">-->
            </div>

            <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[1,2])" @click.stop="back()"><i class="iconfont icon-left-01"></i></div>

            <div class="box input" @click.stop="back()" v-if="$store.state.mapStore.isShow(moduleState,[0,1])">
                <input type="text" v-model="inputValue" :placeholder="placeholder" readonly="readonly" onfocus="javascript:this.blur()" :disabled="!inputValue?true:false" />
                <i class="iconfont icon-yuyin1" @click.stop="voice=1"></i>
            </div>

            <div class="box input" :state="moduleState" v-if="$store.state.mapStore.isShow(moduleState,[2])">
                <i class="iconfont icon-dianpuhuodong"></i>
                共<span>{{$BRT.$active.shopDatas.total}}</span>个企业广告推送,分布<span v-if="$BRT.$active.shopDatas.floors">{{$BRT.$active.shopDatas.floors.length}}</span>层
            </div>

            <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[1,2])" @click.stop="closeFilter"><i class="iconfont icon-close-02"></i></div>

        </div>

        <div class="voice-container" :style="{backgroundImage:'url('+voiceBg+')'}" v-if="voice">

            <p class="p1" v-if="[1,2].indexOf(voice)>-1">
                <span v-if="voice == 1">可长按语音按钮说</span>
                <span v-else>松开即可搜索</span>
            </p>

            <p class="p2" v-if="[1,2,3].indexOf(voice)>-1">
                <span v-if="voice == 1">电梯</span>
                <span v-else-if="voice == 2">正在聆听...</span>
                <span v-else>稍候，识别中...</span>
            </p>

            <p class="p3" v-if="voice == 4">
                <span>识别失败，请重试</span>
            </p>

            <div class="icon-box">
                <i class="iconfont icon-yuyin1" v-if="[1,2,4].indexOf(voice) > -1" @touchstart.stop="startVoice" @touchend.stop="endVoice"></i>
                <i class="iconfont icon-jiazaizhong"  v-else></i>
                <i class="voiceLoad" v-if="voice == 2"></i>
            </div>

            <div class="close-box" @click="closevoice">
                <i class="iconfont icon-cha"></i>
            </div>

        </div>

    </div>

</template>

<script>
    import $voiceBg from "@/assets/voiceBg.jpg"

    let voice_s = '',
        voice_e = '',
        countTime = '';

    export default {
        name: "SearchModule",

        data(){

            return {
                moduleState:0,
                inputValue:'',
                placeholder:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).searchVal ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).searchVal : '查找设施、企业、服务台',
                voiceBg:$voiceBg,
                voice:0,     //1 显示 2录音 3识别 4识别结果
                voiceId:''
            }
        },

        created(){

            this.bus.$off('pointFilter');
            this.bus.$on('pointFilter',(res)=>{

                this.inputValue = res.NAME;
                this.moduleState = 1;

            })

            //关闭
            this.bus.$off('pointFilterClose');
            this.bus.$on('pointFilterClose',()=>{
                this.inputValue = '';
                this.moduleState = 0;
            });

            //回退
            this.bus.$off('pointFilterBack');
            this.bus.$on('pointFilterBack',()=>{

                if(this.$BRT.$filter.enter == 'Filter'){    //返回筛选列表

                    this.$BRT.$filter.enter = '';
                    this.$mapStep.type = 'toFilter';
                    this.$BRT.$options.PoiListData = '';
                    this.bus.$emit('colSelectedFilter');

                    // let $data = JSON.parse(JSON.stringify(this.$BRT.$options.PoiListData));
                    // this.$BRT.$options.PoiListData = '';
                    // setTimeout(()=>{
                    //     this.$BRT.$options.PoiListData = $data;
                    // },10)

                }else if(this.$BRT.$filter.initEnter == 'search'){     //返回搜索页面

                    this.$router.replace('/search');
                    this.$BRT.$filter.open = false;
                    this.$BRT.$filter.initEnter= '';
                    this.$BRT.$filter.enter = '';
                    this.closeFilter();

                } else if(this.$BRT.$filter.initEnter == 'classify'){   //逛品牌

                    this.$router.replace('/classify');
                    this.$BRT.$filter.open = false;
                    this.$BRT.$filter.initEnter= '';
                    this.$BRT.$filter.enter = '';

                } else if(this.$BRT.$filter.initEnter == 'activeDetail'){   //活动详情

                    this.$router.replace(this.$BRT.$active.initEnter);
                    this.$BRT.$active.initEnter = '';
                    this.$BRT.$marker.selected.empty();

                    this.$BRT.$filter.open = false;
                    this.$BRT.$filter.initEnter= '';
                    this.$BRT.$filter.enter = '';

                }else{

                    this.$mapStep.type = '';
                    this.$BRT.$filter.open = false;
                    this.$BRT.$filter.initEnter= '';
                    this.$BRT.$filter.enter = '';
                }

            })


            //改动值
            this.bus.$off('filter_search_value')
            this.bus.$on('filter_search_value',(res)=>{
                this.inputValue = res;
            })
        },

        methods:{

            back(){

                if(this.moduleState == 1 || this.moduleState == 0){

                    if(this.$BRT.$filter.open){

                        this.bus.$emit('pointFilterBack');

                    }else{

                        this.$router.replace('/search');

                    }


                }else if(this.moduleState == 2){

                    this.$message.load(true);

                    this.$router.replace('/activity');
                    this.$mapStep.type = '';
                    this.moduleState = 0;
                }

            },

            closeFilter(){

                if(this.moduleState == 1){

                    //清空检索跟踪
                    let retrievalTracking = this.$store.state.retrievalTracking;
                    retrievalTracking.state = false;
                    retrievalTracking.NAME = '';
                    retrievalTracking.CATEGORY_ID = '';


                    this.$BRT.$options.PoiListDrawer= 0;    //关闭筛选
                    this.$mapStep.type = '';
                    this.moduleState = 0;
                    this.inputValue = '';
                    this.$BRT.$filter.open = false;
                    this.$BRT.$filter.initEnter= '';
                    this.$BRT.$filter.enter = '';

                    //清除筛选插标
                    let poiMarkers = $VAR.PoiListMaker;
                    if(poiMarkers.length){
                        for(let i=0;i<poiMarkers.length;i++){
                            if(poiMarkers[i].maker){
                                poiMarkers[i].maker.empty();
                            }
                        }
                    }

                    $VAR.PoiListMaker=[];

                }

                else if(this.moduleState == 2){
                    this.$mapStep.type = '';
                    this.moduleState = 0;
                }

            },

            setClick(){
                this.$BRT.$options.GuideDrawer = true;
            },

            startVoice(){

                if(!voice_s)voice_s = +new Date();
                this.voice = 2;
                this.wx.startRecord();
            },

            endVoice(){
                // console.log('触摸结束');
                let $this = this;

                /*测试数据*/
                // $this.bus.$emit('voiceFilter',{
                //     resetName:'',
                //     name:'电梯',
                //     mapID:''
                // })
                // this.voice = 0;
                /*测试数据*/
                /**/
                this.wx.stopRecord({
                    success(res){
                        // console.log('录音成功',res,'$this.voice',$this.voice);

                        if(+new Date() - voice_s < 1000){
                            $this.$message.info('录音时间太短');
                            $this.voice = 1;
                            return;
                        }

                        voice_s = '';
                        if($this.voice == 2){

                            $this.voice = 3;

                            if(countTime){
                                clearTimeout(countTime);
                                countTime='';
                            }

                            //6s未解析视为解析失败
                            countTime = setTimeout(()=>{
                                if($this.voice == 3){$this.voice =4;}
                            },6000);

                            // $this.wx.playVoice({localId:res.localId})
                            $this.wx.uploadVoice({
                                localId:res.localId,
                                isShowProgressTips:1,
                                success:result=>{

                                    $this.$request.get(`${$this.$axiosBaseUrl}/api/v1/speech/toWords?media_id=${result.serverId}&language=${$this.$BRT.language}`).then($result=>{
                                        // console.log('文字解析结果1',$result);

                                        if(countTime){
                                            clearTimeout(countTime);
                                            countTime='';
                                        }

                                        if($this.voice ==3){
                                            if($result.data.code == 0 && $result.data.result){

                                                $this.bus.$emit('voiceFilter',{
                                                    resetName:'',
                                                    name:$result.data.result,
                                                    mapID:''
                                                })

                                                $this.voice = 0;

                                            }
                                            else{
                                                $this.voice = 4;
                                            }
                                        }

                                    }).catch(err=>{
                                        // $this.$message.info('上传解析文件失败');
                                        $this.voice = 4;

                                        if(countTime){
                                            clearTimeout(countTime);
                                            countTime='';
                                        }

                                    })

                                },
                                error:err=>{
                                    // $this.$message.info('微信上传语音失败');
                                    $this.voice = 4;
                                    if(countTime){
                                        clearTimeout(countTime);
                                        countTime='';
                                    }
                                }
                            })
                        }
                    },
                    error(err){
                        // $this.$message.info('停止录音失败');
                        $this.voice = 3;
                        voice_s = '';
                        if(countTime){
                            clearTimeout(countTime);
                            countTime='';
                        }
                    }
                })
                 /**/
            },

            closevoice(){
                if(countTime){
                    clearTimeout(countTime);
                    countTime='';
                }
                this.voice = 0;
            }
        },

        watch:{

            $PoiListData(v1,v2){

                if(this.$mapStep.type =='toFilter'){

                    this.inputValue = v1.NAME ? v1.NAME : v1.CATEGORY_NAME ;
                    this.moduleState = 1;
                }

            },

            $mapStepType(v1,v2){

                if(v1 == 'shopActive'){

                    this.moduleState = 2;
                }

                if(!v1){this.closeFilter();}
            }

        },

        computed:{

            $PoiListData(){
                return this.$BRT.$options.PoiListData
            },

            $mapStepType(){
                return this.$mapStep.type
            }

        },

        mounted(){

            //单店活动
            if(this.$mapStep.type == 'shopActive'){

                this.moduleState = 2;

            }else if(this.$mapStep.type =='toFilter'){
                this.inputValue = this.$BRT.$options.PoiListData.NAME ? this.$BRT.$options.PoiListData.NAME : this.$BRT.$options.PoiListData.CATEGORY_NAME ;
                this.moduleState = 1;
            }


        }

    }
</script>

<style lang="less">
    @import "SearchModule.less";
</style>
